module.exports = __webpack_public_path__ + "img/40t.d253992c.jpg";